/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationGroupType } from './OrganizationGroupType';
import {
    OrganizationGroupTypeFromJSON,
    OrganizationGroupTypeFromJSONTyped,
    OrganizationGroupTypeToJSON,
    OrganizationGroupTypeToJSONTyped,
} from './OrganizationGroupType';

/**
 * 
 * @export
 * @interface OrganizationGroupResponse
 */
export interface OrganizationGroupResponse {
    /**
     * 
     * @type {string}
     * @memberof OrganizationGroupResponse
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationGroupResponse
     */
    name?: string | null;
    /**
     * 
     * @type {any}
     * @memberof OrganizationGroupResponse
     */
    organizationCount?: any | null;
    /**
     * 
     * @type {any}
     * @memberof OrganizationGroupResponse
     */
    organizationGroupId?: any | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationGroupResponse
     */
    shortName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationGroupResponse
     */
    applicationId?: string | null;
    /**
     * 
     * @type {OrganizationGroupType}
     * @memberof OrganizationGroupResponse
     */
    organizationGroupType?: OrganizationGroupType;
}



/**
 * Check if a given object implements the OrganizationGroupResponse interface.
 */
export function instanceOfOrganizationGroupResponse(value: object): value is OrganizationGroupResponse {
    return true;
}

export function OrganizationGroupResponseFromJSON(json: any): OrganizationGroupResponse {
    return OrganizationGroupResponseFromJSONTyped(json, false);
}

export function OrganizationGroupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationGroupResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] === undefined ? undefined : json['description'] === null ? null : json['description'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'organizationCount': json['organizationCount'] === undefined ? undefined : json['organizationCount'] === null ? null : json['organizationCount'],
        'organizationGroupId': json['organizationGroupId'] === undefined ? undefined : json['organizationGroupId'] === null ? null : json['organizationGroupId'],
        'shortName': json['shortName'] === undefined ? undefined : json['shortName'] === null ? null : json['shortName'],
        'applicationId': json['applicationId'] === undefined ? undefined : json['applicationId'] === null ? null : json['applicationId'],
        'organizationGroupType': json['organizationGroupType'] == null ? undefined : OrganizationGroupTypeFromJSON(json['organizationGroupType']),
    };
}

export function OrganizationGroupResponseToJSON(json: any): OrganizationGroupResponse {
    return OrganizationGroupResponseToJSONTyped(json, false);
}

export function OrganizationGroupResponseToJSONTyped(value?: OrganizationGroupResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'name': value['name'],
        'organizationCount': value['organizationCount'],
        'organizationGroupId': value['organizationGroupId'],
        'shortName': value['shortName'],
        'applicationId': value['applicationId'],
        'organizationGroupType': OrganizationGroupTypeToJSON(value['organizationGroupType']),
    };
}

